import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import AddressmanagerService from "app/data/address-manager/addressService";

export const useAddressCounts = () => {
  const { data: addressCounts, isLoading: isLoadingAddressCounts, refetch: refetchAddressCounts } = useQuery({
    queryKey: [QUERY_KEYS.ADDRESS_COUNTS],
    queryFn: async () => {
      const response = await AddressmanagerService.getInstance().getAddressCounts();
      return response;
    },
    refetchOnWindowFocus: false,
    retry: false,
  })
  return { addressCounts, isLoadingAddressCounts, refetchAddressCounts };
}